export function randomToken(bytes: number = 32): string {
  const arr = new Uint8Array(bytes);
  crypto.getRandomValues(arr);
  return Array.from(arr, b => b.toString(16).padStart(2, '0')).join('');
}

export function getCookie(name: string): string | null {
  const value = document.cookie.split('; ').find(row => row.startsWith(name + '='));
  return value ? decodeURIComponent(value.split('=')[1]) : null;
}

export function setCookie(name: string, value: string, days = 1) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Expires=${expires}; SameSite=Lax; Secure`;
}

export function ensureCSRFToken(): string {
  let token = getCookie('csrftoken');
  if (!token) {
    token = randomToken(32);
    setCookie('csrftoken', token);
  }
  return token;
}

export function getCSRFToken(): string | null {
  return getCookie('csrftoken');
}

